var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.52216C0 4.13706 0.191209 3.75196 0.549726 3.52543L5.42555 0.240759C6.81181 -0.688011 8.29368 1.30545 6.93132 2.23422L5.28214 3.34421H16.7093C18.4063 3.34421 18.4063 5.79073 16.7093 5.79073H5.40165L6.93132 6.81011C8.31758 7.73888 6.81181 9.73234 5.42555 8.80357L0.549726 5.51889C0.191209 5.29236 0 4.92992 0 4.52216ZM4.08718e-07 13.538C4.08718e-07 12.8584 0.573625 12.3148 1.29066 12.3148H12.7179L11.0687 11.2048C9.70632 10.276 11.1882 8.28255 12.5744 9.21132L17.4503 12.496C17.7849 12.7225 18 13.1076 18 13.4927C18 13.8778 17.8088 14.2629 17.4503 14.4895L12.5744 17.7741C12.0008 18.1592 11.1882 18.046 10.7819 17.4796C9.84972 16.1431 11.714 15.3956 12.5983 14.7386H1.29066C0.573625 14.7613 4.08718e-07 14.195 4.08718e-07 13.538Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsCompare);
export default __webpack_public_path__ + "static/media/arrows-compare.90de1594fe1bd00ab9deeeb1b5386fef.svg";
export { ForwardRef as ReactComponent };